/**
 * 📦 DATA INDEX
 * 
 * Master export for all game data.
 * Import from here for convenience:
 * 
 *   import { buildings, technologies, quests, BALANCE } from './data';
 */

// Core balance configuration
export { 
  BALANCE, 
  calculateBuildingCost, 
  calculateProduction, 
  getKingdomTier,
  getPlayerEra,
  getBaseResearchTime,
  calculateResearchTime,
  formatTime,
  getClickPower,
  getResearchSpeedMultiplier
} from './balance';

// Game entities
export { resources, getResourcesByTier, getStarterResources, getResourceCount } from './resources';
export { 
  buildings, 
  getBuildingsByTier, 
  getBuildingCount, 
  getBuildingsUnlockedByTech,
  getStarterBuildings,
  getTierStats,
  TIER_01_BUILDINGS,
  TIER_02_BUILDINGS,
  TIER_03_BUILDINGS,
  TIER_04_BUILDINGS,
  TIER_05_BUILDINGS,
  TIER_06_BUILDINGS,
  TIER_07_BUILDINGS,
  TIER_08_BUILDINGS,
  TIER_09_BUILDINGS,
  TIER_10_BUILDINGS,
  TIER_11_BUILDINGS,
} from './buildings';
export { technologies, getTechsByTier, getTechCount, getAvailableTechs, getStarterTechs } from './technologies';
export { 
  quests, 
  getQuestIds,
  getQuestCount,
  getQuest,
} from './quests';
export { upgrades, getUpgradeCount, getAvailableUpgrades } from './upgrades';

// World Wonders system
export {
  WONDERS,
  WONDER_BALANCE,
  getWondersByTier,
  getWonder,
  getWonderTiers,
  canAffordWonder,
  calculateWonderBuildTime,
  formatWonderTime,
  getEraName,
} from './wonders';

// Default export with everything
const gameData = {
  BALANCE: require('./balance').BALANCE,
  resources: require('./resources').resources,
  buildings: require('./buildings').buildings,
  technologies: require('./technologies').technologies,
  quests: require('./quests').quests,
  upgrades: require('./upgrades').upgrades,
  WONDERS: require('./wonders').WONDERS,
};

export default gameData;
